import React from "react";
import { connect } from "react-redux";
import { Actions as AUTHENTICATION_ACTIONS } from "../../store/actions/authenticationActions";

const CreateDemoCompany = ({ createDemoCompany }) => {
	return (
		<div
			style={{
				textAlign: "center",
				margin: "auto",
				marginTop: 50,
				marginBottom: 50,
			}}
		>
			<h1
				style={{
					textAlign: "center",
					marginBottom: 20,
				}}
			>
				Welcome to your Buddy Account
			</h1>
			<p>At this point in time there is no Demo Account linked to your personal profile.</p>
			<p>Click below to create a Demo Account and explore Buddy</p>
			<div
				className="btn btn-success"
				style={{ marginRight: 10 }}
				onClick={() => createDemoCompany("MT")}
			>
				Create Malta Demo Account
			</div>
			<div
				className="btn btn-success"
				onClick={() => createDemoCompany("UK")}
			>
				Create UK Demo Account
			</div>
			<p style={{ marginTop: 20 }}>
				If you're looking for your employee portal or to view your payslips,{" "}
				<a href="https://employee.buddy.hr">click here</a>
			</p>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	createDemoCompany: (country) => dispatch(AUTHENTICATION_ACTIONS.createDemoCompany(country)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateDemoCompany);
